export default __webpack_public_path__ + "static/media/integrityIcon.dde9e738.png";